import PropTypes from 'prop-types';

import TrackKey from './TrackKey';

const TrackKeys = ({
  tracks,
  toggleOpen,
  clickTrackButton,
  isSubTrack = false,
}) => {
  return (
    <ul>
      {tracks.map((track, index) => (
        <TrackKey
          key={track.id}
          track={track}
          toggleOpen={toggleOpen}
          clickTrackButton={clickTrackButton}
          isSubTrack={isSubTrack}
          user={(tracks ?? [])?.[index]?.user ?? {}}
        />
      ))}
    </ul>
  );
};

TrackKeys.propTypes = {
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  toggleOpen: PropTypes.func,
  clickTrackButton: PropTypes.func,
};

export default TrackKeys;
